import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { DashboardPageFormBody } from '@shigo-ui/dashboard-ui';
import { ConfirmDialog } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../../lib/messages';
import type { IntegrationFormValue } from '../../../integrationFormSchema';
import { IntegrationAttachedLists } from './IntegrationAttachedLists';
import { IntegrationInlineRewrite } from './IntegrationInlineRewrite';
import { ManageIntegrationListsDialog } from './ManageIntegrationListsDialog';

export function IntegrationRewriteFields() {
  const form = useFormContext<IntegrationFormValue>();
  const [manageOpen, setManageOpen] = React.useState(false);
  const [clearOpen, setClearOpen] = React.useState(false);
  const listRewrites = form.watch('listRewrites');
  const listSchains = form.watch('listSchains');

  return (
    <>
      <DashboardPageFormBody
        width="lg"
        title={dashboardT('integrations.tabs.rewrite')}
        description={dashboardT('integrations.rewriteDescription')}
      >
        <IntegrationAttachedLists
          rewrites={listRewrites}
          schains={listSchains}
          onManage={() => {
            setManageOpen(true);
          }}
          onClear={() => {
            setClearOpen(true);
          }}
        />
        <IntegrationInlineRewrite />
      </DashboardPageFormBody>
      {manageOpen ? (
        <ManageIntegrationListsDialog
          open
          selectedRewrites={listRewrites}
          selectedSchains={listSchains}
          onOpenChange={setManageOpen}
          onConfirm={({ listRewrites: nextRewrites, listSchains: nextSchains }) => {
            form.setValue('listRewrites', nextRewrites, { shouldDirty: true });
            form.setValue('listSchains', nextSchains, { shouldDirty: true });
          }}
        />
      ) : null}
      <ConfirmDialog
        open={clearOpen}
        onOpenChange={setClearOpen}
        title={dashboardT('integrations.rewrite.clearTitle')}
        description={dashboardT('integrations.rewrite.clearDescription')}
        cancelLabel={dashboardT('integrations.cancel')}
        confirmLabel={dashboardT('integrations.rewrite.clearConfirm')}
        destructive
        onConfirm={() => {
          form.setValue('listRewrites', [], { shouldDirty: true });
          form.setValue('listSchains', [], { shouldDirty: true });
          setClearOpen(false);
        }}
      />
    </>
  );
}
